import React, { useEffect, useState } from "react";
import { DatePicker, Input, Radio, TimePicker, Row, Col, Select } from "antd";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { robOptions } from "../../../Data/data";
const { Option } = Select;

function EditVoyage() {
  const { id } = useParams();
  const [voyage_type, set_voyage_type] = useState("laden");
  const [voyage_time, set_voyage_time] = useState("");
  const [voyage_date, set_voyage_date] = useState("");
  const [voyage_no, set_voyage_no] = useState("");
  const [loadPorts, set_loadPorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [dischargePorts, set_dischargePorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [charterer_speed, set_charterer_speed] = useState("");
  const [fuel_consumption, set_fuel_consumption] = useState("");
  const [fuelData, setFuelData] = useState([]);

  const VIEW_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      post(ApiURL.view_voyage_info_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const details = res?.voyage_details;
          set_voyage_type(details.voyage_type || "laden");
          set_voyage_time(details.voyage_time || "");
          set_voyage_date(details.voyage_date || "");
          set_voyage_no(details.voyage_no || "");
          set_loadPorts(
            Array.isArray(details.load_ports) && details.load_ports.length > 0
              ? details.load_ports
              : [{ port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" }]
          );
          set_dischargePorts(
            Array.isArray(details.discharge_ports) && details.discharge_ports.length > 0
              ? details.discharge_ports
              : [{ port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" }]
          );
          setFuelData(
            Array.isArray(details.rob_fuel) && details.rob_fuel.length > 0
              ? details.rob_fuel
              : [{ fuelType: null, Initialiy_rob: "" }]
          );
          set_charterer_speed(details.charterer_speed || "");
          set_fuel_consumption(details.fuel_consumption || "");
        }
      });
    } catch (error) {
      console.log("show Error ***********", error);
    }
  };

  useEffect(() => {
    VIEW_API();
  }, []);

  return (
    <div className="white-container">
      <h3>View Voyage</h3>
      <br />
      <Row gutter={[16, 16]} className="margin-top">
        <Col span={12}>
          <label className="block-label">Voyage Number</label>
          <Input value={voyage_no} disabled />
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="margin-top">
        <Col span={12}>
          <label className="block-label">Time</label>
          <TimePicker
            value={voyage_time ? dayjs(voyage_time, "HH:mm:ss") : null}
            style={{ width: "100%" }}
            defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
            disabled
          />
        </Col>
        <Col span={12}>
          <label className="block-label">Date</label>
          <DatePicker
            value={voyage_date ? dayjs(voyage_date) : null}
            style={{ width: "100%" }}
            disabled
          />
        </Col>
      </Row>
      <Row className="margin-top">
        <Col span={24}>
          <label className="block-label">Voyage Type</label>
          <Radio.Group value={voyage_type} disabled>
            <Radio value={"laden"}>Laden</Radio>
            <Radio value={"ballast"}>Ballast</Radio>
          </Radio.Group>
        </Col>
      </Row>

      {/* Load Ports Section */}
      <div className="margin-top">
        <h4>Load Port(s)</h4>
        {loadPorts.map((port, index) => (
          <div key={index} style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label className="block-label">Port Name</label>
                <Input value={port.port_name} disabled />
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
              <Col span={6}>
                <label className="block-label">Arrival Draft</label>
                <Input value={port.arrival_draft} disabled />
              </Col>
              <Col span={6}>
                <label className="block-label">ETA</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  value={port.eta ? dayjs(port.eta) : null}
                  style={{ width: "100%" }}
                  disabled
                />
              </Col>
              <Col span={6}>
                <label className="block-label">Departure Draft</label>
                <Input value={port.departure_draft} disabled />
              </Col>
              <Col span={6}>
                <label className="block-label">ETD</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  value={port.etd ? dayjs(port.etd) : null}
                  style={{ width: "100%" }}
                  disabled
                />
              </Col>
            </Row>
          </div>
        ))}
      </div>

      {/* Discharge Ports Section */}
      <div className="margin-top">
        <h4>Discharge Port(s)</h4>
        {dischargePorts.map((port, index) => (
          <div key={index} style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label className="block-label">Port Name</label>
                <Input value={port.port_name} disabled />
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
              <Col span={6}>
                <label className="block-label">Arrival Draft</label>
                <Input value={port.arrival_draft} disabled />
              </Col>
              <Col span={6}>
                <label className="block-label">ETA</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  value={port.eta ? dayjs(port.eta) : null}
                  style={{ width: "100%" }}
                  disabled
                />
              </Col>
              <Col span={6}>
                <label className="block-label">Departure Draft</label>
                <Input value={port.departure_draft} disabled />
              </Col>
              <Col span={6}>
                <label className="block-label">ETD</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  value={port.etd ? dayjs(port.etd) : null}
                  style={{ width: "100%" }}
                  disabled
                />
              </Col>
            </Row>
          </div>
        ))}
      </div>

      {/* Charterer Details */}
      <Row gutter={[16, 16]} className="margin-top">
        <Col span={12}>
          <label className="block-label">Instructed Charterer's Speed</label>
          <Input value={charterer_speed} disabled />
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="margin-top">
        <Col span={12}>
          <label className="block-label">Instructed Charterer's Fuel Consumption</label>
          <Input value={fuel_consumption} disabled />
        </Col>
      </Row>
      <div className="margin-top">
        <h4>Fuel / Lub Types and Initial ROB</h4>
        {fuelData.map((item, index) => (
          <div key={index} style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label className="block-label">Select Fuel / Lub Type</label>
                <Select
                  disabled
                  placeholder="-- Select Fuel Type --"
                  style={{ width: "100%" }}
                  value={item.fuelType}
                  // onChange={(value) => handleFuelChange(index, "fuelType", value)}
                  allowClear
                >
                  {Array.isArray(robOptions) &&
                    robOptions.map((fuel, i) => (
                      <Option key={i} value={fuel.value}>
                        {fuel.label}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={6}>
                <label className="block-label">Initial ROB ({item.fuelType || "-"})</label>
                <Input
                  disabled
                  value={item.Initial_rob}
                  // onChange={(e) => handleFuelChange(index, "Initialiy_rob", e.target.value)}
                  placeholder="Enter ROB value"
                  type="number"
                />
              </Col>
              <Col span={6}>
                <label className="block-label">Current ROB ({item.fuelType || "-"})</label>
                <Input
                  disabled
                  value={item.Initialiy_rob}
                  // onChange={(e) => handleFuelChange(index, "Initialiy_rob", e.target.value)}
                  placeholder="Enter ROB value"
                  type="number"
                />
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EditVoyage;
